const HeaderChangeColor = () => {
  let lastScrollTop = 0; // 前回のスクロール位置を保持する変数

  window.addEventListener('scroll', function () {
    // l-header__wrap エレメントを取得
    var headerWrap = document.querySelector('.l-header__wrap');

    if (headerWrap) {
      // ページのトップからのスクロール距離
      var scrollDistance = window.pageYOffset || document.documentElement.scrollTop;

      // 画面の高さ
      var screenHeight = window.innerHeight;

      // スクロール距離が画面の高さ以上になったらクラスを追加
      if (scrollDistance >= (screenHeight / 2)) {
        headerWrap.classList.add('active');
        this.setTimeout(() => {
          headerWrap.classList.add('transition');
        }, 300);
      } else {
        // それ以下の場合はactiveクラスを削除
        headerWrap.classList.remove('active');
        headerWrap.classList.remove('transition');
      }

      // スクロール方向を判定
      if (scrollDistance > lastScrollTop) {
        // 下にスクロール
        headerWrap.classList.remove('is-down');
      } else {
        // 上にスクロール
        headerWrap.classList.add('is-down');
      }

      // 前回のスクロール位置を更新
      lastScrollTop = scrollDistance <= 0 ? 0 : scrollDistance; // スクロール位置が負にならないようにする
    }
  });
}

HeaderChangeColor();